/**
 * Created by mqamhieh on 12/26/16.
 */
window.CustomLanesAPI = new function () {

    var self = this;
    var _protected = BaseAPI.call(self);

    var getCustomLaneBase = function (brandId, jobId) {
        if (!brandId) {
            hLog("API", "CUSTOM_LANE", "No brand id set, given:" + brandId + " job:" + jobId);
            return null;
        }

        var url = "brands/" + brandId;

        if (jobId) {
            url += "/jobs/" + jobId
        }

        url += "/ams";
        return url;
    };

    self.addJobSwimLane = function (brandId, jobId, laneData) {
        var defer = $q.defer();

        _protected.request(getCustomLaneBase(brandId, jobId) + "/swimlanes", "POST", laneData)
            .then(function (res) {
                if (res && res.data && res.data.status_code === 200) {
                    defer.resolve(res.data.data.swimlane);
                }
                else {
                    defer.reject(res.data);
                }
            }, function (error) {
                defer.reject(error.data);
            });

        return defer.promise;
    };

    self.getBrandSkeleton = function (brandId) {
        var defer = $q.defer();

        _protected.request(getCustomLaneBase(brandId, null) +  "/skeleton", "GET")
            .then(function (res) {
                if (res && res.data && res.data.status_code === 200) {
                    defer.resolve(res.data.data.skeleton);
                }
                else {
                    defer.reject(res.data);
                }
            }, function (error) {
                defer.reject(error.data);
            });

        return defer.promise;
    };

    self.archiveLane = function (laneId, brandId, jobId) {
        var defer = $q.defer();

        _protected.request(getCustomLaneBase(brandId, jobId) + "/swimlanes/" + laneId, "PUT",
            {
                status: 'ARCHIVED'
            })
            .then(function (res) {
                if (res && res.data && res.data.status_code === 200) {
                    defer.resolve(res.data);
                }
                else {
                    defer.reject(res.data);
                }
            }, function (error) {
                defer.reject(error.data);
            });

        return defer.promise;
    };

    self.editLane = function (data, laneId, brandId, jobId) {
        var defer = $q.defer();

        _protected.request(getCustomLaneBase(brandId, jobId) + "/swimlanes/" + laneId, "PUT", data)
            .then(function (res) {
                if (res && res.data && res.data.status_code === 200) {
                    defer.resolve(res.data);
                }
                else {
                    defer.reject(res.data);
                }
            }, function (error) {
                defer.reject(error.data);
            });

        return defer.promise;
    };

    self.getTemplates = function (laneId, brandId, jobId, options) {
        var defer = $q.defer();
        options = $.extend({ include_parent: false, load: null }, options);

        _protected.request(getCustomLaneBase(brandId, jobId) + "/swimlanes/" + laneId + "/templates", "GET", options)
            .then(function (res) {
                if (res && res.data && res.data.status_code === 200) {
                    defer.resolve(res.data.data);
                }
                else {
                    defer.reject(res.data);
                }
            }, function (error) {
                defer.reject(error.data);
            });

        return defer.promise;
    };

    self.getTemplateDetails = function (templateId, laneId, brandId, jobId) {
        var defer = $q.defer();

        _protected.request(getCustomLaneBase(brandId, jobId) + "/swimlanes/" + laneId + "/templates/" + templateId, "GET")
            .then(function (res) {
                if (res && res.data && res.data.status_code === 200) {
                    defer.resolve(res.data.data.template);
                }
                else {
                    defer.reject(res.data);
                }
            }, function (error) {
                defer.reject(error.data);
            });

        return defer.promise;
    };

    self.deleteTemplate = function (templateId, laneId, brandId, jobId) {
        var defer = $q.defer();

        _protected.request(getCustomLaneBase(brandId, jobId) + "/swimlanes/" + laneId + "/templates/" + templateId, "DELETE")
            .then(function (res) {
                if (res && res.data && res.data.status_code === 200) {
                    defer.resolve(res.data);
                }
                else {
                    defer.reject(res.data);
                }
            }, function (error) {
                defer.reject(error.data);
            });

        return defer.promise;
    };

    self.applyToChildBrands = function (brandId) {
        var defer = $q.defer();

        _protected.request(getCustomLaneBase(brandId) + "/skeleton/inherit", "POST", {})
            .then(function (res) {
                if (res && res.data && res.data.status_code === 200) {
                    defer.resolve(res.data);
                }
                else {
                    defer.reject(res.data);
                }
            }, function (error) {
                defer.reject(error.data);
            });

        return defer.promise;
    };

    self.getArchivedLanes = function (brandId, jobId) {
        var defer = $q.defer();

        _protected.request(getCustomLaneBase(brandId, jobId) + "/swimlanes", "GET", {
            'status': 'ARCHIVED'
        })
            .then(function (res) {
                if (res && res.data && res.data.status_code === 200) {
                    defer.resolve(res.data.data.swimlanes);
                }
                else {
                    defer.reject(res.data);
                }
            }, function (error) {
                defer.reject(error.data);
            });

        return defer.promise;
    };

    self.activateLane = function (laneId, afterLaneId, brandId, jobId) {
        var defer = $q.defer();

        _protected.request(getCustomLaneBase(brandId, jobId) + "/swimlanes/" + laneId, "PUT", {
            'status': 'ACTIVE',
            'after': afterLaneId
        })
            .then(function (res) {
                if (res && res.data && res.data.status_code === 200 && res.data.data) {
                    defer.resolve(res.data.data.swimlane);
                }
                else {
                    defer.reject(res.data);
                }
            }, function (error) {
                defer.reject(error.data);
            });

        return defer.promise;
    };

    self.getCreateTemplateURL = function (laneId, brandId, jobId) {
        return publicConfiguration.APIServerBaseURL + getCustomLaneBase(brandId, jobId) + "/swimlanes/" + laneId + "/templates";
    };
};